import { render, staticRenderFns } from "./ViAdmissionHome.vue?vue&type=template&id=d313deaa&scoped=true"
import script from "./ViAdmissionHome.vue?vue&type=script&lang=js"
export * from "./ViAdmissionHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d313deaa",
  null
  
)

export default component.exports